import React, { useState, useRef, useEffect } from 'react';
import { AppBar, Toolbar, Typography, Button, Menu, MenuItem, Link, Avatar } from '@mui/material';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import axios from 'axios';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import MenuIcon from '@mui/icons-material/Menu';
import '../../custom'
import Popover from '@mui/material/Popover';
import NotificationComponent from '../companyWall/NotificationComponent';
import { callApi } from '../../common/api';
import { createDeviceToken } from '../../common/FirebaseCall';
import Notifications from '../../Notifications';
import { useLocation } from 'react-router-dom';

function InvestorNavigationBar() {
  const [dataProp, setDataProp] = useState([])
  const [isSignedUp, setSignedUp] = useState(false)
  const [userName, setUserName] = React.useState("")
  const url = process.env.REACT_APP_STRAPI_API
  const feUrl = process.env.REACT_APP_CMSFE_URL

  React.useEffect(() => {
    getDetails()
    getData()
    const authenticate = localStorage.getItem("authenticate");
    if (authenticate === 'true') {
      setSignedUp(true);
    } else {
      setSignedUp(false)
    }
  }, []);

  async function getDetails() {
    try {
      const response = await callApi('get', 'userRegister')
      const data = response.data.response.data
      const firstName = data?.firstName.slice(0, 1).toUpperCase()
      const lastName = data?.lastName.slice(0, 1).toUpperCase()
      const name = firstName.concat(lastName)
      setUserName(name)
    } catch (error) {
      console.log(error, "error")
    }
  }
  async function getData() {
    const HeaderResponse = await axios.get(`${url}/api/headers?populate=*`)
    const Headerdata = HeaderResponse.data.data
    setDataProp(Headerdata)
  }
  
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorSn, setAnchorSn] = React.useState(null);
  const menuRef = useRef(null);
  const open = Boolean(anchorEl);
  const openSignup = Boolean(anchorSn)

  const handleMenuOpen = (event) => {
    // setAnchorEl(event.currentTarget);
    window.location.href = (`/invest`)
  };
  const portfolio = (event) => {
    window.location.href = (`/portfolio`)

  }

  const location = useLocation();
  const pathname = location.pathname;

  // URL se sirf path ko extract karne ke baad, aap usko split karke last segment ko extract kar sakte hain
  const segments = pathname.split('/');
  const paramValue = segments[segments.length - 1]; // Last segment

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleEvents = (event) => {
    window.location.href = (`${feUrl}/events`)
  };

  const handleSignupClose = () => {
    setAnchorSn(null);
  };
  const routeToHome = () => {
    window.location.href = (`/discover`)
  }

  const routeToProfile = () => {
    window.location.href = "/investor"
  }

  const routeToEvent = () => {
    window.location.href = (`${feUrl}/blogs`)
  }
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setAnchorSn(null);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const handleLogOutClick = async () => {
    // const firebaseToken = await createDeviceToken();
    let token = JSON.parse(localStorage.getItem("accessToken"))
    let obj = {
      accessToken: token
    }
    const response = await callApi("post", "auth/logout", obj)
    localStorage.clear();
    // const firbaseResponse = await callApi('post',`admin/deleteDeviceToken?deviceToken=${firebaseToken}`)
    window.location.href = `${process.env.REACT_APP_LANDING_PAGE_URL}?logout=true`
  }

  const handleLinkClick = async () => {
    // const firebaseToken = await createDeviceToken()
    let token = JSON.parse(localStorage.getItem("accessToken"))
    let obj = {
      accessToken: token
    }
    const response = await callApi("post", "auth/logout", obj)
    localStorage.clear();
    // const firbaseResponse = await callApi('post',`admin/deleteDeviceToken?deviceToken=${firebaseToken}`)
    window.location.href = `${process.env.REACT_APP_LANDING_PAGE_URL}?logout=true`

  }
  const handleLogOutOpen = (event) => {
    if (openSignup) {
      setAnchorSn(null); // Close the menu if it's already open
    } else {
      setAnchorSn(event.currentTarget); // Open the menu
    }
  };
  const [anchorEle, setAnchorEle] = React.useState(null);
  const [showNotificationBanner, setShowNotificationBanner] = useState(Notification.permission === 'default');

  const handleNotificationClick = (event) => {
    setAnchorEle(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEle(null);
  };

  const [array, setArray] = useState([])
  const getNotification = async () => {
    const response = await callApi("get", "investor/allNotifications")
    setArray(response?.data?.response?.data)
  }

  React.useEffect(() => {
    let allData = localStorage.getItem("allData")
    let parsed = JSON.parse(allData)
    if (parsed?.registrationStep > 2) {
      getNotification()
    }
  }, [])


  return (
    <>
      <header id="myHeader">
        <Popover
          open={Boolean(anchorEle)}
          anchorEl={anchorEle}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <div
            style={{
              backgroundColor: 'black',
              borderRadius: '8px',
              width: '500px',
              padding: '16px',
              overflow: 'auto',
              maxHeight: '500px',
            }}
          >
            <NotificationComponent array={array} />
          </div>
        </Popover>
        <div className="sidewarper">
          <div id="slidesection">
            <div className="headerinner">
              <div className="topclose "><a href="#" style={{ float: 'left' }}><img src={`${dataProp[0]?.attributes?.HeaderLogo?.data?.attributes?.url}`} alt="" width="165" className="img-fluid" /></a> <a id="slide1" style={{ float: 'right' }} className="white row2"><CloseIcon sx={{ color: 'white' }} /></a></div>
              <br></br>
              <div className="overscroll">

                <div className="container">
                  <div className="footerinformation">
                    <ul>
                      <li ><Link href='/discover'>Discover</Link></li>
                      <li ><a href='/allstartups'>Invest</a></li>
                      <li><a href={`${feUrl}/blogs`}>Blogs</a></li>
                      {/* <li><a href={`${feUrl}/events`}>Events</a></li> */}
                      {/* <li><a href='/portfolio'>My Portfolio</a></li> */}
                      <li><a href='/watchlist'>Watchlist</a></li>
                    </ul>
                  </div>
                  {isSignedUp ? <a href={`${feUrl}/?type=investor`} onClick={handleLogOutClick} className="commanbutton bg-white ms-3 d-block text-center">Log Out</a> :
                    <a href={`${feUrl}/?type=investor`} className="commanbutton bg-white ms-3 d-block text-center">{dataProp[0]?.attributes?.ButtonText}</a>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container py-3">
        <div className="d-flex justify-content-between m-0 align-items-center">
  <div className="logo">
    <a href="#">
      <img src={`${dataProp[0]?.attributes?.HeaderLogo?.data?.attributes?.url}`} alt="" width="165" className="img-fluid" />
    </a>
  </div>
  <div className="mainlinks mobilenone">
    <ul className="d-flex justify-content-center m-0 align-items-center">
      <li className="nav-item"><a style={{fontWeight: paramValue === "discover" ? "600" : "normal" }} href="/discover" className="nav-link">Discover</a></li>
      <li className="nav-item"><a style={{fontWeight: paramValue === "allstartups" ? "600" : "normal" }} href="/allstartups" className="nav-link">Invest</a></li>
      <li className="nav-item"><a href={`${feUrl}/blogs`} className="nav-link">Blogs</a></li>
      {/* <li className="nav-item"><a href={`${feUrl}/events`} className="nav-link">Events</a></li> */}
      {/* <li className="nav-item"><a href='/portfolio' className="nav-link">My Portfolio</a></li>  */}
    </ul>
  </div>
  <div className="d-flex justify-content-end m-0 align-items-center">
    <div className="d-none d-sm-block d-md-flex justify-content-lg-between align-items-md-center mobilenone w-75" style={{ gap: "8px" }}>
      <a style={{fontWeight: paramValue === "watchlist" ? "600" : "normal", color: "white" }} href='/watchlist'>Watchlist</a>
      {/* <NotificationsOutlinedIcon onClick={handleNotificationClick} style={{ cursor: "pointer", height: "24px" }} fontSize="large" className='text-light' /> */}
      <button style={{ backgroundColor: "white", border: "none", cursor: "pointer", width: "80px", height: "45px", borderRadius: '30px', fontSize: '20px' }} onClick={() => window.location.href = "/investor"}>{userName ? userName : <Avatar />}</button>
      <Button sx={{ paddingLeft: "0px", maxWidth: "none", minWidth: "0%" }} className="text-light p-md-0" onClick={handleLogOutOpen} endIcon={<KeyboardArrowDownOutlinedIcon />} ></Button>
      <Menu
        anchorEl={anchorSn}
        open={openSignup}
        className='border'
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        ref={menuRef}
      >
        <MenuItem onClick={() => window.location.href = "/investor"}>
          <Link className="logoutHover" style={{ textDecoration: 'none' }} color="inherit">
            Profile
          </Link>
        </MenuItem>
        <MenuItem onClick={handleSignupClose}>
          <Link className="logoutHover" style={{ textDecoration: 'none' }} to={`/login`} onClick={() => { handleLinkClick() }} color="inherit">
            Log out
          </Link>
        </MenuItem>        
      </Menu>
    </div>
    <div className="d-flex align-items-center">
      <div className="d-block d-md-none" style={{ marginRight: '10px' }}>
        <button style={{ backgroundColor: "white", border: "none", cursor: "pointer", width: "40px", height: "40px", borderRadius: '50%', fontSize: '20px' }} onClick={() => window.location.href = "/investor"}>{userName ? userName : <Avatar />}</button>
      </div>
      <a id="slide" className="float-left"><MenuIcon sx={{ color: 'white' }} /></a>
    </div>
  </div>
</div>

        </div>
        {/* <Notifications/> */}
      </header>
    </>
  )
}

export default InvestorNavigationBar
